<template>
  <form action>
    <div class="modal-card" style="width:auto">
      <header class="modal-card-head">
        <h4 class="modal-card-title">Shipment Certificate</h4>
      </header>
      <section class="modal-card-body">
        <approve-certificate :data="data" :print="print"></approve-certificate>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
      </footer>
    </div>
  </form>
</template>

<script>
import ApproveCertificate from "./ApproveCertificate.vue";
import { mapGetters } from "vuex";

export default {
  name: "UpdateModal",
  components: { ApproveCertificate },
  props: {
    data: { type: Object, required: true },
    print: true
  }
};
</script>
<style scoped>
.currentStatus {
  text-transform: uppercase;
  font-weight: bolder;
  margin-left: 15px;
}
</style>
